import { useQuery } from "@apollo/client";

import { SettingsObservationTypeEditRoute_GetByIdDocument } from "../queries.generated";

export default function useSettingsObservationTypeEditRoute_GetById(observationTypeId: string) {
    const { data, loading, error } = useQuery(SettingsObservationTypeEditRoute_GetByIdDocument, {
        variables: { id: observationTypeId },
    });

    return {
        observationType: data?.settingsObservationTypeGetById,
        loading,
        error,
    };
}
